// extracted by mini-css-extract-plugin
export default {"page":"page__IV+3p"};